// import '@babel/polyfill';
import 'url-search-params-polyfill';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n/i18n';

import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/scss/custom.min.css'

Vue.config.productionTip = false;
Vue.config.performance = true;
Vue.config.errorHandler = (err, vm, info) => {
  // エラー処理 todo: 必要だったら
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
